import { createContext, useEffect, useReducer } from "react"
import { auth } from "../firebase/config"


export const AuthContext = createContext()

export const authReducer = (state, action) => {
  
  switch (action.type) {
    case 'LOGIN':
      return { ...state, user: action.payload }
    case 'LOGOUT':
      return { ...state, user: null, customClaims: null }
    case 'AUTH_IS_READY':
      return { ...state, user: action.payload, authIsReady: true }
    case 'SET_CUSTOM_CLAIMS':
      return { ...state, customClaims: action.payload }
    default: 
      return state
  }
}

export const AuthContextProvider = ({ children }) => {
  const [ state, dispatch ] = useReducer(authReducer, {
    user: null,
    customClaims: null,
    authIsReady: false
  })

  useEffect(() => {
    const unsub = auth.onAuthStateChanged(async(user) => {

      // required if page is refreshed
      if (user) {
        // Force refresh to get latest claims when auth state changes
        await user.getIdToken(true)
        const idTokenResult = await user.getIdTokenResult()
        
        dispatch({ type: 'SET_CUSTOM_CLAIMS', payload: idTokenResult.claims })
      }
      dispatch({ type: 'AUTH_IS_READY', payload: user })
      
      return () => unsub()
    })
  }, [])

  return (
    <AuthContext.Provider value={{ ...state, dispatch }}>
      { children }
    </AuthContext.Provider>
  )
}